import React from "react";
import Header from "shared/components/header";
import Sidebar from "shared/components/sidebar";

import "./application-layout.css";

function ApplicationLayout(props) {
  const { children, user, ...restProps } = props;
  return (
    <div className="application">
      <Header user={user} {...restProps}/>
      <Sidebar />
      <main className="col-md-12">
        {React.Children.map(children, child =>
          React.cloneElement(child, props)
        )}
      </main>
    </div>
  );
}

export default ApplicationLayout;



// WEBPACK FOOTER //
// ./src/shared/components/application-layout.js